<template>
    <v-autocomplete
        ref="field"
        :data-cy="dataCy"
        outlined
        single-line
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: `BaseAutocomplete`,
    props: {
        dataCy: {
            type: String,
            default: ``
        }
    }
}
</script>
